import ShareIcon from "@mui/icons-material/Share";
import LockIcon from "@mui/icons-material/Lock";
import { Tooltip } from "@mui/material";
import { Chart } from "../../models/chart";

const ChartShareIcon: React.FC<{ chart: Chart }> = ({ chart }) => {
  return (
    <>
      {(chart.parentChart?.isDefault || chart.isDefault) && (
        <Tooltip
          className="ms-2"
          title={
            chart.isSharedDataChanged
              ? "Default Chart Changed, reset to default"
              : "Default Chart"
          }
        >
          <LockIcon
            style={{
              fontSize: "14px",
              marginTop: "2px",
              color: chart.isSharedDataChanged ? "orange" : "initial",
            }}
          />
        </Tooltip>
      )}
      {(chart.parentChart?.isShared || chart.isShared) &&
        !(chart.parentChart?.isDefault || chart.isDefault) && (
          <Tooltip
            className="ms-2"
            title={
              chart.isSharedDataChanged
                ? "Shared Chart Changed, reset to default"
                : "Shared Chart"
            }
          >
            <ShareIcon
              style={{
                fontSize: "16px",
                marginTop: "2px",
                color: chart.isSharedDataChanged ? "orange" : "initial",
              }}
            />
          </Tooltip>
        )}
    </>
  );
};

export default ChartShareIcon;
